import { Component, define } from '@theme/component';

class HeroSlider extends Component {
  init() {
    this.track = this.$('.hero-slider__track');
    this.slides = this.$$('.hero-slider__slide');
    this.prevBtn = this.$('.hero-slider__arrow--prev');
    this.nextBtn = this.$('.hero-slider__arrow--next');
    this.currentIndex = 0;

    if (!this.track || this.slides.length < 2) return;

    this.prevBtn?.addEventListener('click', () => this.go(-1));
    this.nextBtn?.addEventListener('click', () => this.go(1));

    // Keep the index in sync when the visitor swipes
    this.track.addEventListener(
      'scroll',
      () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.currentIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
        }, 100);
      },
      { passive: true },
    );

    this.initAutoplay();
  }

  disconnectedCallback() {
    clearInterval(this.autoplayTimer);
  }

  go(direction) {
    this.currentIndex = Math.max(
      0,
      Math.min(this.currentIndex + direction, this.slides.length - 1),
    );

    this.scrollToSlide(this.currentIndex);
    this.startAutoplay();
  }

  // Scrolls the track only; scrollIntoView would also scroll the page
  scrollToSlide(index) {
    this.track.scrollTo({
      left: index * this.track.clientWidth,
      behavior: 'smooth',
    });
  }

  initAutoplay() {
    const seconds = Number(this.dataset.autoplaySpeed);
    if (!seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.autoplayDelay = seconds * 1000;

    // Pause while the visitor is about to click (text, button, arrows) or tabs through the slider
    this.$$('.hero-slider__content-inner, .hero-slider__arrow').forEach((el) => {
      el.addEventListener('mouseenter', () => this.setPaused(true));
      el.addEventListener('mouseleave', () => this.setPaused(false));
    });
    this.addEventListener('focusin', (event) => {
      if (event.target.matches(':focus-visible')) this.setPaused(true);
    });
    this.addEventListener('focusout', () => this.setPaused(false));
    this.track.addEventListener('touchstart', () => this.startAutoplay(), { passive: true });

    this.startAutoplay();
  }

  setPaused(paused) {
    this.paused = paused;
    this.startAutoplay();
  }

  startAutoplay() {
    clearInterval(this.autoplayTimer);
    if (!this.autoplayDelay || this.paused) return;

    this.autoplayTimer = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.scrollToSlide(this.currentIndex);
    }, this.autoplayDelay);
  }
}

define('hero-slider', HeroSlider);
